
const digest = 'e4ff958c94937db1047f24cceb32c6819661a9b6f2a73dbf303766ac9abf4285';
const classes = {"button":"_button_14vph_1"};
const css = `._button_14vph_1 {
  font-family: "Rubik", sans-serif;
  border-left: 4px solid #1665d8;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  padding: 24px;
  border-top: 1px solid #eaedf3;
  border-bottom: 1px solid #eaedf3;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  